import { render, staticRenderFns } from "./BrandsBlock.vue?vue&type=template&id=2385d4aa&scoped=true"
import script from "./BrandsBlock.vue?vue&type=script&lang=js"
export * from "./BrandsBlock.vue?vue&type=script&lang=js"
import style0 from "./BrandsBlock.vue?vue&type=style&index=0&id=2385d4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2385d4aa",
  null
  
)

export default component.exports